import mondaySdk from "monday-sdk-js";

const monday = mondaySdk();

export const valueCreated = () => {
  monday.execute('valueCreatedForUser');
}